import {
  ADD_TO_CART,
  DECREMENT_QUANTITY,
  DELETE_CART,
  INCREMENT_QUANTITY,
} from "./actionType";
import { initialState } from "./initialState";

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_TO_CART:
      const existingItem = state.cartItems.find(
        (item) => item.id === action.payload.id
      );
      if (existingItem) {
        return {
          ...state,
          cartItems: state.cartItems.map((item) => {
            if (item.id === action.payload.id) {
              return {
                ...item,
                quantity: item.quantity + 1,
              };
            }
            return item;
          }),
        };
      } else {
        return {
          ...state,
          cartItems: [...state.cartItems, { ...action.payload, quantity: 1 }],
        };
      }

    case INCREMENT_QUANTITY:
      return {
        ...state,
        cartItems: state.cartItems.map((cart) => {
          if (cart.id === action.payload) {
            return {
              ...cart,
              quantity: cart.quantity + 1,
            };
          }
          return cart;
        }),
      };
    case DECREMENT_QUANTITY:
      return {
        ...state,
        cartItems: state.cartItems.map((cart) => {
          if (cart.id === action.payload) {
            return {
              ...cart,
              quantity: cart.quantity - 1,
            };
          }
          return cart;
        }),
      };

    case DELETE_CART:
      return {
        ...state,
        cartItems: state.cartItems.filter((cart) => cart.id !== action.payload),
      };

    default:
      return state;
  }
};

export default reducer;
